/** Build a stable, human-readable filename for a catalog clip imported into
 *  freecut. Pattern: `${categorySlug}-${idShort}.mp4`. The slug is the AI
 *  category lowercased with non-alphanumerics collapsed to a single dash;
 *  `idShort` is the first 8 hex chars of the catalog UUID (dashes stripped).
 *  Falls back to "clip" when the category is missing or slugifies to empty. */
export function makeFilename(clip: { id: string; category: string | null }): string {
  const slug = slugify(clip.category ?? '') || 'clip'
  const idShort = clip.id.replace(/-/g, '').slice(0, 8)
  return `${slug}-${idShort}.mp4`
}

function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
